import p from"styled-components";const o=p.div`
	border-radius: ${({borderRadius:p})=>"number"==typeof p?p:14}px;
	background: ${({theme:p})=>p.bg.card};
	box-shadow: 0px 0.633px 3.163px 0px rgba(63, 65, 66, 0.2);
	padding: ${({isTemplate:p})=>p?"10px":"16px"};
`;export{o as PageContainer};
